import axios from 'axios';

const instance = axios.create({
    baseURL: 'https://nueva.retroalimentame.com.mx'
    //baseURL: 'https://nueva.retroalimentame.com.mx:9728'
    //baseURL: 'http://192.168.1.66:9728'
});

export default instance;
